import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { OrderAppType } from "../../shared/helpers/helper.common";
import { CountryMaster } from "../../shared/models/country.model";
import { CoreService } from "../../shared/services/core.service";
import { LoginService } from "../../shared/services/login.service";
import { UserService } from "../../shared/services/user.service";
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule } from "@angular/forms";
import { NgStyle, AsyncPipe } from "@angular/common";
@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"],
  standalone: true,
  imports: [NgStyle, FormsModule, NgSelectModule, AsyncPipe],
})

// Import required modules and classes
export class RegisterComponent implements OnInit {
  // Observable for Merchant data
  Merchant$ = this.coreService.Merchant$;
  // Array to store country data
  Country: CountryMaster[];
  // Variable to store the selected country
  selectedCountry: any;
  // String to store the dial code of the selected country
  dialcode: string = "";
  // Boolean flag to indicate if the user accepted the policy
  isPolicy: boolean = false;
  // Reference to the modal element
  modal;

  // Constructor to initialize class dependencies
  constructor(
    private _router: Router,
    private coreService: CoreService,
    private RegistrationService: LoginService,
    private userService: UserService
  ) {}

  // Lifecycle hook: ngOnInit
  ngOnInit() {
    // Get the reference to the modal element
    this.modal = document.getElementById("myModal");

    // Fetch country data from the coreService
    this.coreService.getCountry().subscribe((resp) => {
      if (resp.data) {
        // Store country data in the Country array
        this.Country = resp.data;

        // Subscribe to the Merchant$ observable to get data from the server
        this.coreService.Merchant$.subscribe((data) => {
          if (data && data.address) {
            // Set the default merchant country code based on the address.country value
            let mycountry: CountryMaster = this.Country.find(
              (x) => x.name == data.address.country
            );
            if (mycountry) {
              this.selectedCountry = mycountry;
              this.dialcode = mycountry.dial_code;
            }
          }
        });
      }
    });
  }

  // Method to handle the ValueChange event of the country dropdown
  ValueChange(country) {
    // Update the dialcode based on the selected country's dial_code
    this.dialcode = country.dial_code;
  }

  // Method to attempt user registration using the provided form data
  attempRegistration(Form) {
    if (!Form.valid) {
      return;
    }

    // Prepare the userInfo object with registration details
    var userInfo = {
      register_from: OrderAppType.webapp,
      first_name: Form.form.value.FirstName,
      last_name: Form.form.value.LastName,
      dial_code: this.dialcode,
      phone_number: Form.form.value.Mobile,
      password: Form.form.value.Password,
      email: Form.form.value.Email,
      phone_number_length: this.selectedCountry.contact_number_length,
    };

    // Call the registration service to perform user registration
    this.RegistrationService.registration(userInfo).subscribe(
      (resp) => {
        // Handle the response data after successful registration
        if (resp) {
          const data = resp?.data ?? resp;
          // Store user details in local storage and emit data using UserSub subject from coreService
          localStorage.setItem("currentUser", JSON.stringify(data));
          this.coreService.UserSub.next(data);

          if (data?.token && !data?.user) {
            this.userService.GetUserProfile().subscribe(
              (profile) => {
                const registeredUser = {
                  ...data,
                  user: profile?.user,
                  success: 1,
                };
                localStorage.setItem(
                  "currentUser",
                  JSON.stringify(registeredUser)
                );
                this.coreService.UserSub.next(registeredUser);
                this._router.navigate(["/dashboard"]);
              },
              () => {
                this._router.navigate(["/dashboard"]);
              }
            );
            return;
          }

          this._router.navigate(["/dashboard"]);
        }
      },
      (error) => {
        // Handle errors during registration
        if (error.status === 422) {
          alert(JSON.stringify(error?.error?.errors));
        } else {
          alert(JSON.stringify(error?.error?.errors));
        }
      }
    );
  }

  // Method to check the value of an event (used for debugging)
  checkValue(event: any) {}

  // Method to handle the PolicyPopup display and actions
  PolicyPopup(Action: number, event: any = null) {
    if (Action === 1) {
      if (event.currentTarget.checked) {
        this.modal.style.display = "block";
      }
    } else if (Action === 2) {
      this.isPolicy = false;
      this.modal.style.display = "none";
    } else if (Action === 3) {
      this.isPolicy = true;
      this.modal.style.display = "none";
    }
  }

  close() {
    this.modal.style.display = "none";
  }
}
